import { render, staticRenderFns } from "./research-data.vue?vue&type=template&id=bce0f1ec&scoped=true&lang=pug&"
import script from "./research-data.vue?vue&type=script&lang=ts&"
export * from "./research-data.vue?vue&type=script&lang=ts&"
import style0 from "./research-data.vue?vue&type=style&index=0&id=bce0f1ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce0f1ec",
  null
  
)

export default component.exports